module.exports = require("./nmg-CM");